import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'ds-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DsSelectOptionComponent {
  @Input() value: string | number;
  @Input() disabled?: boolean;

  @ViewChild(TemplateRef, { static: true }) content: TemplateRef<unknown>;
}
